import React from 'react';
import { Placement } from '@floating-ui/react';
import cs from 'classnames';

import { Box } from 'shared/components/display';
import { DropdownChildren, DropdownOffset } from 'shared/components/molecules/Dropdown';
import Elliptical from 'shared/components/molecules/Elliptical';

import COLORS from 'shared/styles/colors';

import styles from './styles';

interface Props {
  className?: string;
  placement?: Placement;
  color?: string;
  children: DropdownChildren;
  height?: string;
  width?: string | number;
  portalTarget?: string;
  dataCy?: string;
  id?: string;
  disablePortal?: boolean;
  debug?: boolean;
  offset?: DropdownOffset;
}

const EllipticalMenu: React.FC<Props> = ({
  placement = 'top-end',
  color = COLORS.NEUTRAL300,
  className,
  children,
  width,
  height = 'min-content',
  portalTarget,
  dataCy,
  id,
  disablePortal,
  debug,
  offset,
}) => {
  return (
    <Box css={styles(height)} id={id} className={cs('elliptical-menu', className)}>
      <Elliptical
        className="elliptical-menu__inner-content"
        color={color}
        placement={placement}
        width={width}
        portalTarget={portalTarget}
        dataCy={dataCy}
        disablePortal={disablePortal}
        debug={debug}
        isVertical
        offset={offset}
      >
        {children}
      </Elliptical>
    </Box>
  );
};

export default EllipticalMenu;
